import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { ConsultaCnpjService } from '../consulta-cnpj.service';
import { ArquivoService } from '../../shared/services/arquivo.service';


@Component({
  templateUrl: './gerenciar-consulta-cnpj.component.html',
})
export class GerenciarConsultaCnpjComponent extends WebPage implements OnInit {

  empresas = [];

  constructor(
    private confirmationService: ConfirmationService, messageService: MessageService,
    private consultaCnpjService: ConsultaCnpjService,
    private arquivoService: ArquivoService
  ) {
    super(messageService);
  }

  ngOnInit() {
    this.isLoading = true;
    this.consultaCnpjService.getEmpresasParaAvaliar()
      .subscribe(empresas => {
        this.empresas = empresas;
        this.isLoading = false;
      },
      error => this.gerenciaErro(error)
    );
  }

  gerarExcel() {
    this.isLoading = true;
    this.arquivoService.DownloadExcelConsultasCnpj()
      .finally(() => this.isLoading = false)
      .subscribe(
        blob => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'Report.xlsx';
          link.click();
        },
        error => this.gerenciaErro(error)
      );
  }

  deferirEmpresa(empresa) {
    if (empresa.statusEmpresa !== 'PENDENTE' && empresa.statusEmpresa !== 'INVÁLIDO') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Empresa deve estar pendente ou inválida pra ser deferida.'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja alterar o status deste CNPJ para “Deferido”?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.consultaCnpjService.deferirEmpresa(empresa.idEmpresa)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              if (response === 'OK') {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Atenção',
                  detail: 'Empresa de CNPJ ' + empresa.cnpj + ' foi deferida.'
                });
                this.empresas.splice(this.empresas.indexOf(empresa), 1);
              }
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Ação cancelada.' });
      }
    });
  }

  indeferirEmpresa(empresa) {
    if (empresa.statusEmpresa !== 'PENDENTE' && empresa.statusEmpresa !== 'INVÁLIDO') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Empresa deve estar pendente ou inválida pra ser indeferida.'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja alterar o status deste CNPJ para “Indeferido”?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.isLoading = true;
        this.consultaCnpjService.indeferirEmpresa(empresa.idEmpresa)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              if (response === 'OK') {
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Atenção',
                  detail: 'Empresa de CNPJ ' + empresa.cnpj + ' foi indeferida.'
                });
                this.empresas.splice(this.empresas.indexOf(empresa), 1);
              }
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Ação cancelada.' });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/consultaCnpj/gerenciar-consulta-cnpj/gerenciar-consulta-cnpj.component.ts